import React from 'react'
import { Nav, NavDropdown, Spinner } from 'react-bootstrap'

function LandingHeaderActions({
  loadingUser,
  userInfo,
  onOpenModal,
  onLogout,
  onGoToDashboard,
  compact = false,
}) {
  return (
    <div className={`landing-header-actions ${compact ? 'compact' : ''}`}>
      {loadingUser ? (
        <Spinner animation='border' variant='light' as={'div'} style={{ width: '20px', height: '20px' }} />
      ) : userInfo ? (
        <Nav className='landing-account-nav'>
          <NavDropdown className='no-chevron' menuVariant='dark' title={userInfo.name} id={`landing-account-dropdown-${compact ? 'compact' : 'full'}`}>
            <NavDropdown.Item onClick={onGoToDashboard} style={{ fontSize: '16px' }} className='text-white'>
              Dashboard
            </NavDropdown.Item>
            <NavDropdown.Item onClick={onLogout} style={{ fontSize: '16px' }} className='text-white'>
              Sign Out
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      ) : (
        <div className='landing-auth-actions'>
          <button onClick={() => onOpenModal('login')} className='landing-auth-link' type='button'>Log In</button>
          <button onClick={() => onOpenModal('register')} className='landing-auth-button' type='button'>Register</button>
        </div>
      )}
    </div>
  )
}

export default LandingHeaderActions
